import { render, staticRenderFns } from "./ServiceCollect.vue?vue&type=template&id=bca11c0c&"
import script from "./ServiceCollect.vue?vue&type=script&lang=js&"
export * from "./ServiceCollect.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCollect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports